// Main Routes
export const ROUTE_MAIN = '/'
export const ROUTE_DASHBOARD = '/dashboard'
export const ROUTE_HOME = `/home`
export const ROUTE_BROWSE = `${ROUTE_DASHBOARD}/browse`
export const ROUTE_PLAYERS = `${ROUTE_BROWSE}/players`
export const ROUTE_PLAY = `${ROUTE_BROWSE}/play`
export const ROUTE_PLAYER_PROFILE = `${ROUTE_DASHBOARD}/player`
export const ROUTE_NEW_MATCH = `${ROUTE_DASHBOARD}/match/new`
export const ROUTE_CLUBS = `${ROUTE_BROWSE}/clubs`
export const ROUTE_MY_CLUBS = `${ROUTE_CLUBS}/my`
export const ROUTE_CLUB_MANAGEMENT = `${ROUTE_DASHBOARD}/clubs/management`
export const ROUTE_EVENTS = `${ROUTE_BROWSE}/events`
export const ROUTE_SEARCH_RESULTS = `${ROUTE_BROWSE}/search-results`
export const ROUTE_PROFILE = `${ROUTE_DASHBOARD}/user/profile`
export const ROUTE_PREFERENCES = `${ROUTE_DASHBOARD}/user/preferences`
export const ROUTE_PASSWORD_SECURITY = `${ROUTE_DASHBOARD}/user/pass-security`
// MFA management is a sub-section of Password & Security (the other being change-password).
export const ROUTE_TWO_FACTOR = `${ROUTE_PASSWORD_SECURITY}/two-factor`
// The pre-restructure address, kept only as a redirect so old links and bookmarks still land.
export const ROUTE_TWO_FACTOR_LEGACY = `${ROUTE_DASHBOARD}/user/two-factor`
export const ROUTE_CONNECTIONS = `${ROUTE_DASHBOARD}/user/connections`
export const ROUTE_SUBSCRIPTION = `${ROUTE_DASHBOARD}/subscription`
// Linkable on purpose: the paywall claim prompt, a club page, and the grant email all need
// somewhere to send a member, and `?claim=<grantId>` opens straight into the club picker.
export const ROUTE_MY_BENEFITS = `${ROUTE_DASHBOARD}/benefits`
// The club picker as its own URL. What opens it is usually not the benefits page — a superwall
// placement, a push, the grant email — and all of those need one address to send someone to.
// `grantId` is optional because superwall knows the member has something claimable, not which row.
export const ROUTE_CLAIM_BENEFIT = `${ROUTE_MY_BENEFITS}/claim`

// A coach's published profile. Addressed by KIND and id, not by id alone: `independent-coach` and
// `club-coach` are separate kinds that can each hold id 7, so the pair is the identity — the same
// addressing the entity API uses, kept identical here so a URL can be built from an entity URN
// without a lookup table.
export const ROUTE_COACHES = `${ROUTE_BROWSE}/coaches`
export const ROUTE_COACH_PROFILE = `${ROUTE_COACHES}/:kind/:entityId`
// The coach's own side of the same feature: who has claimed a lesson with them, and what they
// offer. Under `dashboard` rather than `browse` because it is a place of work, not discovery.
export const ROUTE_MY_COACHING = `${ROUTE_DASHBOARD}/coaching`

export const ROUTE_DUPR_REPLAY = `${ROUTE_DASHBOARD}/replay`
export const ROUTE_MATCH = `${ROUTE_DASHBOARD}/match/detail/:matchId`

// Auth Routes
export const ROUTE_LOGIN = '/login'
export const ROUTE_CLAIM = '/claim'
export const ROUTE_SIGNUP = '/signup'
export const ROUTE_HARD_SUBSCRIBE = '/subscribe'
export const ROUTE_VERIFY_NUMBER = `${ROUTE_SIGNUP}/verify-number`
export const ROUTE_CREATE_PASSWORD = `${ROUTE_SIGNUP}/submit`
// The email-first signup link lands here; the profile form redeems the token and builds the request.
export const ROUTE_SIGNUP_LANDING = `${ROUTE_SIGNUP}/:token`
export const ROUTE_SIGNUP_LANDING_BASE = ROUTE_SIGNUP
export const ROUTE_FORGOT_PASSWORD = '/password'
export const ROUTE_VERIFY_EMAIL = `${ROUTE_FORGOT_PASSWORD}/verify-email`
export const ROUTE_REST_PASSWORD = `${ROUTE_FORGOT_PASSWORD}/reset`
export const ROUTE_VERIFY = '/email/verify/:token'
// The verify route without its :token param, for substring matching (e.g. the protected-page
// redirect guard, which sees the resolved pathname, not the pattern).
export const ROUTE_VERIFY_BASE = '/email/verify'
export const ROUTE_RESET_PASSWORD = '/reset-password'
export const ROUTE_RESET_PASSWORD_TOKEN = `${ROUTE_RESET_PASSWORD}/:token`

// Static Routes
export const ROUTE_PRIVACY_POLICY = '/privacy-policy'
export const ROUTE_SUPPORT = '/support'
export const ROUTE_TERMS = '/terms'
export const ROUTE_LIFETIME = '/lifetime'
export const ROUTE_VERIFY_PHONE = '/dashboard/verify-phone'

// Access Routes, Not Access Routes
export const ROUTE_ACCESSED_LOGGED = [ROUTE_DASHBOARD, ROUTE_PLAYERS, ROUTE_CLUBS, ROUTE_PROFILE, ROUTE_NEW_MATCH]
export const ROUTE_NOT_ACCESSED_LOGGED = [ROUTE_SIGNUP, ROUTE_LOGIN, ROUTE_CLAIM]

// External
export const ROUTE_WEB_SESSION = '/web-session'
export const ROUTE_EXTERNAL_LOGIN = '/login-external-app'
export const ROUTE_PREMIUM_LOGIN = '/premium-login'
export const ROUTE_REDEEM_CODE = '/redeem'
export const ROUTE_EXTERNAL_CLAIM = `/claim-external-app`
export const ROUTE_EXTERNAL_SIGNUP = '/signup-external-app'
export const ROUTE_EXTERNAL_THIS_ACCOUNT_IS_ALREADY_TAKEN = '/account-taken-external-app'
export const ROUTE_EXTERNAL_VERIFY_PHONE = '/verify-phone-external-app'
export const ROUTE_EXTERNAL_CREATE_PASSWORD = '/create-password-external-app'
export const ROUTE_EXTERNAL_LINK_SUCCESS = '/premium-account-link-success'

export const ROUTE_MEMBERSHIP_REQUIRED = '/membership-required'

// OAuth 2.0 embedded-SSO flow (Authorization Code + PKCE)
// Consent SPA: the partner redirects the browser here after /oauth/v1.0/authorize.
export const ROUTE_OAUTH_AUTHORIZE = '/oauth/authorize'
// Promo resolver: the target for DUPR promo links clicked outside the app/web.
export const ROUTE_CONNECT = '/connect'

// Modal Routes
export const SUBSCRIBER_MODAL_ROUTES = [ROUTE_PLAYERS, `${ROUTE_PLAYER_PROFILE}/:playerId`]
